import React from 'react';

const IconFastAPI = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px">
    <circle cx="24" cy="24" r="22" fill="#009688" />
    {/* Lightning bolt */}
    <path fill="white" d="M28 8 L14 26 L24 26 L20 40 L34 22 L24 22 Z" />
  </svg>
);

export default IconFastAPI;
